import Vue from "vue";
import Vuex from "vuex";
import { Chart, Cards, News, Modals, Sliders } from "./modules";

Vue.use(Vuex);

export default new Vuex.Store({
  namespaced: true,
  state: {
    countries: [],
    hints: {
      home: JSON.parse(localStorage.getItem("home_hints")),
      project: JSON.parse(localStorage.getItem("project_hints"))
    },
    share: {
      icons: [
        {
          src: require("@/assets/images/j3oVA_71D1QCXmUIMFc-C.svg"),
          alt: "vk"
        },
        {
          src: require("@/assets/images/3KFKwAYgHBq6YbCiBeyMZQ.svg"),
          alt: "facebook"
        },
        {
          src: require("@/assets/images/1wSIepCtseCVhUDwJBZcXN.svg"),
          alt: "linkedin"
        }
      ]
    }
  },
  actions: {
    async fetchCountries({ commit }) {
      return fetch(`${process.env.VUE_APP_KZ}/common/get-countries-data`)
        .then(response => response.json())
        .then(({ content }) =>
          commit("pushToState", { key: "countries", value: content })
        );
    }
  },
  mutations: {
    scrollUp() {
      window.scrollTo({
        top: 100,
        behavior: "smooth"
      });
    },
    pushToState(state, { key, value }) {
      state[key] = value;
    },
    manageHints(state, { show, hints }) {
      state.hints = show;
      localStorage.setItem(hints, state.hints);
    }
  },
  getters: {
    countries: state => state.countries,
    hints: state => key => state.hints[key],
    share: state => state.share
  },
  modules: { Chart, Cards, News, Modals, Sliders }
});
